import React from 'react'
import ReactDOM from 'react-dom/client'
// Ensure Firebase config initializes first to avoid TDZ / init-order issues in the bundle
import './firebase/config'
import App from './App'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)

